import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const BreadCrumb = ({ title, pageTitle, back = false }) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    document.title = `Alitqan | ${title}`
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">{title}</h4>

                        <div className="page-title-right">
                            {back ? 
                                <Button
                                    color="secondary"
                                    className="add-btn me-1"
                                    onClick={() => navigate(-1)}
                                    id="create-btn"
                                >
                                    <i className={`align-bottom me-1 ms-1 ${i18n.dir() === 'rtl' ? 'ri-arrow-right-line' : 'ri-arrow-left-line'}`}></i>
                                    {t("Back")}
                                </Button>
                                :
                                <></>
                                // <ol className="breadcrumb m-0">
                                //     <li className="breadcrumb-item"><Link to="#">{pageTitle}</Link></li>
                                //     <li className="breadcrumb-item active">{title}</li>
                                // </ol>
                            }
                        </div>

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;